exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header > .title {\n  font-family: \"Nexa\", sans-serif !important;\n  font-weight: 400;\n  font-size: 1.125rem !important;\n  color: #396753;\n}\n.card-name {\n  position: absolute;\n  top: 100px;\n}", ""]);

// exports
